import { Component, OnInit } from '@angular/core';
import { ContractDto } from 'src/app/models/contractDto';
import { ContractsService } from 'src/app/services/contracts.service';
import { NotificationService } from 'src/app/services/notification.service';
import { NotificationType } from 'src/app/models/notification.message';
import { approveContractAxiom } from 'src/app/models/approveContractAxiom';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TokenService } from 'src/app/services/token.service';
import { RequestApprovalDto } from 'src/app/models/requestapproval-dto';
import { RequestApprovalsService } from 'src/app/services/requestapprovals.service';

@Component({
  selector: 'app-view-approvecontract',
  templateUrl: './view-approvecontract.component.html',
  styleUrls: ['./view-approvecontract.component.css']
})
export class ViewApproveContractComponent implements OnInit {

  ViewRequestVisible = false;
  ApproveRequest: ContractDto | any
  RequestApprovals: RequestApprovalDto[] | undefined;
  currentUser: any

  showCreatedByColumn: boolean = false;
  showFunctionColumn: boolean = false;
  showSelectAxiom: boolean = false;

  axioms: any[] = []; 
  selectedAxiom = 0;
  axiomId = 0;
  isHrbp: boolean = false; 

  constructor(private contractService: ContractsService, private notification: NotificationService,
    private tokenService: TokenService, private requestApprovalService:RequestApprovalsService  ) { }

  Contracts: ContractDto[] | undefined;
  Comment: string = '';
  ngOnInit(): void {
    this.loadRecords();

  }


  async loadRecords() {
    ;
    let resContracts = await this.contractService.getPendingContracts().toPromise();
    this.Contracts = <ContractDto[]>resContracts.responseData;
    console.log('this is contract ', this.Contracts);


    let resAxioms = await this.contractService.getAxioms().toPromise();
    this.axioms = <any[]>resAxioms.responseData;
    // console.log('this is axioms ', this.axioms);



    this.currentUser = this.tokenService.getInfo();

    if (!(this.Contracts[0].createdBy == this.currentUser.profile.email)) { this.showCreatedByColumn = true; }
    if (!(this.Contracts[0].departmentName == this.currentUser.profile.departmentName)) { this.showFunctionColumn = true; }

    if(this.currentUser.profile.departmentName == 'ORGANIZATION & HUMAN RESOURCES'){
      this.isHrbp = true;
    }

 
  }

  onChangeAxiom(event:number)
  {
   this.selectedAxiom = event;
   this.axiomId = event;
   console.log('selcted axiom', this.axiomId );
  }

  async approveContract() {
    ;

    let axiomId;
    if(this.ApproveRequest.axiom){
        let axiom = this.axioms.find(i => i.name === this.ApproveRequest.axiom);
        if(axiom){
          axiomId = axiom.id

        }

   console.log('this.ApproveRequest.axiomId', axiomId );

    }else{
      axiomId = this.axiomId;
   console.log('this.axiomId', axiomId );
    }
    const model: approveContractAxiom = { id: this.ApproveRequest.id, message: this.Comment , token:'', axiomId };

  console.log('this is the payload', model);

      this.contractService.approveContract(model).subscribe({
        next: (data => {
          
          if (data.responseCode == "00") {
            this.notification.sendMessage({
              message: data.message,
              type: NotificationType.success
            });

            this.loadRecords();
            this.close()
          }
          else {

            this.notification.sendMessage({
              message: data.message,
              type: NotificationType.error
            });

          }

        }),
        error: ((error: any) => {
          console.log(error.error);
          ;


          this.notification.sendMessage({
            message: error.error.message,
            type: NotificationType.error
          });
        })

      });

  }

  async rejectContract() {

    if (this.Comment === '') {
      this.notification.sendMessage({
        message: 'Comment is required when rejecting request',
        type: NotificationType.error
      });
    }
    else {
      

        this.close();

         let axiomId;
          if(this.ApproveRequest.axiomId != 0){
            axiomId = this.ApproveRequest.axiomId
          }else{
            axiomId = this.axiomId;
          }
  

        const model: approveContractAxiom = { id: this.ApproveRequest.id, message: this.Comment , token:'', axiomId};

        this.contractService.rejectContract(model).subscribe({
          next: (data => {

            if (data.responseCode == "00") {
              this.notification.sendMessage({
                message: data.message,
                type: NotificationType.success
              });

              this.loadRecords();
              this.close();
            }
            else {

              this.notification.sendMessage({
                message: data.message,
                type: NotificationType.error
              });

            }

          }),
          error: ((error: any) => {
            console.log(error.error);
            ;


            this.notification.sendMessage({
              message: error.error.message,
              type: NotificationType.error
            });
          })

        });
    
    }
  }


  async open(data: ContractDto) {

    this.ViewRequestVisible = true;

    this.ApproveRequest = data;
    let resApprovals = await this.requestApprovalService.getRequestApprovals(data.id).toPromise();
    this.RequestApprovals = <RequestApprovalDto[]>resApprovals.responseData;

  }

  close(): void {
    this.ViewRequestVisible = false;
  }

  cancel(): void {
 return;
  }
 
  confirm(): void {
    alert('click confirm');
  }



}
